$(document).ready(function() {
    if (window.location.href.indexOf("https://www.rosegoldparis.com/pages/conditions-generales-de-vente") > -1) {
        var target = $("p").filter(function() {
            return $(this).text().indexOf('ARTICLE 25 - Programme d\'abonnement ROSE+') > -1;
        });
        if (target.length) {
            $('html, body').animate({
               scrollTop: target.offset().top - 100 
            }, 1000);
        }
    }
});


$(document).ready(function(){
 $(".open").on("click", function(){
  $(".popup, .popup-content").addClass("active");
});
  
$(".close, .popup").on("click", function(){
  $(".popup, .popup-content").removeClass("active");
});

$('.open-popup').on('click', function(e) {
  e.preventDefault
  openpopupnow();
});

$('.popup-close').on('click', function() {
  $('.overlay').removeClass('shown');
});
$('.btn_yes').on('click', function() {
  $('.overlay').removeClass('shown');
}); 
$(document).on('keyup', function(event) {
  if (event.which == 27) { 
    $('.overlay').removeClass('shown');
  };
});
function openpopupnow() {
  var mpopup = $('.overlay');
  mpopup.addClass('shown');
  $(window).on('click', function(e) {
    if(e.target == mpopup[0]){
      mpopup.removeClass('shown'); 
    } 
  }); 
}
 
$(document).on('click', '.comingSoonPopup', function(e){
  e.preventDefault();
  var NameProduct,CapturePopup;
  var NameProduct = $(this).attr('Productname');
  if( NameProduct.lastIndexOf("|") ){
    NameProduct = NameProduct.substring(0, NameProduct.lastIndexOf("|") + 1); 
  }
  NameProduct = NameProduct.replace(/[^A-Z0-9]/ig, "");
  NameProduct = $.trim(NameProduct).toLowerCase();
  $(this).parents('body').find('.ComingSoonCollectionPopup').children('.popUpComingSoonProduct').each(function(){
    CapturePopup = $(this).attr('capturepopup');
    CapturePopup = $.trim(CapturePopup).toLowerCase();
    if( NameProduct == CapturePopup){ 
      $(this).addClass('active');
      return false;
    } 
  });
});


  $(document).ready(function() {
  $('.swatch[data-option-index="0"]').find('input[type="radio"]:first').prop('checked', true);
  $('.swatch[data-option-index="0"]').find('input[type="radio"]:first').trigger('click');
});


  
$(document).on('click', '.comingSoonPopupClose', function(e){  
  e.preventDefault();
  $('.popUpComingSoonProduct').removeClass('active');
  $('body').removeClass('soonPopupMasked');
});

$(document).on('click', '#custom-add-drawer', function(e){
  $('#custom-add-new').addClass('active-side-bar-menu');
  $('body').addClass('body_masked');
}); 
$(document).on('click', '.cv-icon-close', function(e){
  $('#custom-add-new').removeClass('active-side-bar-menu');
  $('body').removeClass('body_masked');
}); 
$(document).click(function (e) {
  if (!$(e.target).closest('#custom-add-drawer, #custom-add-new').length) {
    $('#custom-add-new').removeClass('active-side-bar-menu');
    $('body').removeClass('body_masked');
  }
});
$(document).on('click', '.qtybox .btnqty', function(e){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {qty--;}
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
}); 

  if( $('.SliderWrapAnnouncemnetBar').children('.announcement-bar__message').length > 1 ){
  $('.SliderWrapAnnouncemnetBar').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover:false,
    pauseOnFocus:false
  }); 
  }else{
    $('.SliderWrapAnnouncemnetBar').css('display','block');
  }

  $(document).on('click', '.cv-swatch .color_input_change', function(){
    var mg= $(this).attr('feature_image');
    var vid= $(this).attr('attribute_id');
    $(this).parents('label').addClass('active').siblings().removeClass('active');
    $(this).parents('li').find('img').attr('srcset',mg);
    $(this).parents('.custom_product_main').find('[name=id]').val(vid);
  });

  $(document).on('click', '.index-page-swatch .color_input_change', function(){
    var mg= $(this).attr('feature_image');
    var vid= $(this).attr('attribute_id');
    $(this).parents('label').addClass('active').siblings().removeClass('active');
    $(this).parents('.custom_product_main').find('.mn_image').attr('src',mg);
    $(this).parents('.custom_product_main').find('.mn_image_one').attr('src',mg);
    $(this).parents('.custom_product_main').find('[name=id]').val(vid);
  });

  if ($(window).width() > 749) {
    $('.main_image_product_slide').slick({    
      slidesToShow: 1, 
      slidesToScroll: 1,  
      arrows: false,
      dots: false,  
      fade:true,
      asNavFor: '.thumb_mn_slide'    
    });
    $('.thumb_mn_slide').slick({ 
      slidesToShow: 600,
      slidesToScroll: 1, 
      vertical:true,
      asNavFor: '.main_image_product_slide', 
      dots: false, 
      arrows: false, 
      focusOnSelect: true,
      verticalSwiping:true, 
    });
  } 
  
  if ($(window).width() < 750) {
    $('.main_image_product_slide').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true
    }); 
  }

    $('.product-description-cv .more').click(function(e) {
    e.preventDefault();
    $(this).text(function(i, t) {
      return t == 'Voir moins' ? 'Voir plus' : 'Voir moins';
    }).prev('.product-description-cv .more-cont').slideToggle()
  });

  $('.cv-product-description').css('display','none');
  $('.product-page-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });
  
  $('.image-blog-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    fade:true,
  });
  
  $(".review_highlight").addClass("hide");
  $("#review-cvacc").addClass("hide");

  $("#review-accordion-k").click(function(){
    $("#review-cvacc").toggleClass("hide");
    $(".review_highlight").toggleClass("hide");
  });
  
});

//discount cart  coupon code js
$(document).on('click', '#redemDevPromo', function(){
  event.preventDefault();
  var theUrl = '/checkout?discount=';
  var theDiscount = $('#devPromo').val();
  var toRedirect = theUrl+theDiscount;
  window.location.href = toRedirect;
});

$(document).on('click', '#cv-promofield', function(){
  $("#cv-promofield").addClass("hide");
  $("#remove-cart-text").removeClass("hide");
});
$(document).on('click', '.TextFieldSpan-m72orh-1', function(){
  $(".TextFieldSpan-m72orh-1").css("color", "#f696a8");
});

// end discaount coupon code




function myFunction() {
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("more");
  var btnText = document.getElementById("myBtn");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    btnText.innerHTML = "Voir plus"; 
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnText.innerHTML = "voir moins"; 
    moreText.style.display = "inline";
  }
}

$(function() {
  // Open Popup
  $('[popup-open]').on('click', function() { 
    var popup_name = $(this).attr('popup-open');
    $('[popup-name="' + popup_name + '"]').fadeIn(300);
  });

  // Close Popup
  $('[popup-close]').on('click', function() {
    var popup_name = $(this).attr('popup-close');
    $('[popup-name="' + popup_name + '"]').fadeOut(300);
  });

  // Close Popup When Click Outside
  $('.popup').on('click', function() {
    var popup_name = $(this).find('[popup-close]').attr('popup-close');
    $('[popup-name="' + popup_name + '"]').fadeOut(300);
  }).children().click(function() {
    return false;
  });
});

$(".open-button").click(function(){
  $('body').addClass('cv-popup-add')
});
$(document).click(function (e) {
  if (!$(e.target).closest('.open-button').length) {
    $('body').removeClass('cv-popup-add')
  }
});

$(".close-button").click(function(){
  $('body').removeClass('cv-popup-add') 
});

$("#cv-button--hover").hover(function(){
  $('#AccessibleNav').addClass('cv-nav-hover')
});
$('#AccessibleNav').mouseleave(function()
                               {
  $(this).removeClass('cv-nav-hover')
});

$('#review-accordion-k').click(function(){
  $('#review-accordion-k').toggleClass('active');
});

$('.open-popup').on('click', function() {
  openpopupnow();
});

$('.popup-close').on('click', function() {
  $('.overlay').removeClass('shown');
});
$('.btn_yes').on('click', function() {
  $('.overlay').removeClass('shown');
});
$(document).on('keyup', function(event) {
  if (event.which == 27) { // esc
    $('.overlay').removeClass('shown');
  };
});
function openpopupnow() {
  var mpopup = $('.overlay');
  mpopup.addClass('shown');

  $(window).on('click', function(e) {
    if(e.target == mpopup[0]){
      mpopup.removeClass('shown');
    }
  });
}

$(document).on('click', '.cv-fancybox', function(){
  $('body').addClass('sec-custom-fancy') 
  $.fancybox([
    { href : '#cv-fancybox-popup-form' }
  ]);
});

$(document).click(function (e) {
  if (!$(e.target).closest('.cv-fancybox,.fancybox-opened').length) {
    $('body').removeClass('sec-custom-fancy')
  }
});

$(document).on('click', '.cv-fancy', function(){  
  $('body').addClass('custom-fancy-rose')
  $.fancybox([
    { href : '#cv-fancybox-popup' }
  ]);
});

$(document).click(function (e) {
  if (!$(e.target).closest('.cv-fancy,.fancybox-opened').length) {
    $('body').removeClass('custom-fancy-rose')

  } 
});

$(document).on('click','.quick-view-button', function(){
  $('body').addClass('cv-see-detail');  
});

$(document).click(function (e) {
  if (!$(e.target).closest('.quick-view-button,.fancybox-opened').length) {
    $('body').removeClass('cv-see-detail') 
  }
});

$(document).on('click','.ScrollBtn', function(){
  var TargetScroll = $(this).attr('scroll');
  $('html, body').animate({
    scrollTop: $(TargetScroll).offset().top - 150
  }, 800);
});

$(document).on('click','.CV_bundle_left_struct,.Cv_bundle,.CV_right_content_bundle', function(){
  $('body').addClass('rose-quick-view') 
});

$(document).click(function (e) {
  if (!$(e.target).closest('.CV_bundle_left_struct,.Cv_bundle,.CV_right_content_bundle,.fancybox-opened').length) {
    $('body').removeClass('rose-quick-view') 
  }
}); 

$(document).ready(function(){
  $('.needsclick').addClass('cv-klaviyo');
 
  $('.review-popup-button').click(function(){ 
    $(this).parents('.block-review-section-repeated').addClass('popup-active');
    $('body').addClass('body-masked');
  });

  $('.cv-close').click(function(){
    $(this).parents('.block-review-section-repeated').removeClass('popup-active');
    $('body').removeClass('body-masked')
  });

  $('.accordion_container .accordion_head').on('click touchend', function(e){
    e.preventDefault();
    if( $(this).hasClass('active') ){
      $(this).toggleClass('active');
      $(this).parents('.accordion_container').children('.accordion_body').slideToggle();
    }
    else{
      $('.accordion_head').removeClass('active');
      $('.accordion_body').slideUp();
      $(this).toggleClass('active');
      $(this).parents('.accordion_container').children('.accordion_body').slideToggle();
    }
  }); 
  
  $('.Accordionwrappbox-container .product-accordaion-wrappbox').on('click touchend', function(e){
    e.preventDefault();
    if( $(this).hasClass('active') ){
      $(this).toggleClass('active');
      $(this).parents('.Accordionwrappbox-container').children('.mainAccodain-body').slideToggle();
    }
    else{
      $('.product-accordaion-wrappbox').removeClass('active');
      $('.mainAccodain-body').slideUp();
      $(this).toggleClass('active');
      $(this).parents('.Accordionwrappbox-container').children('.mainAccodain-body').slideToggle();
    }
  }); 

  if ($(window).width() < 769) {
    $('.announcement-bar').children('.blog-logo-jukebx').children('img').click(function(){
      $(this).parents('.announcement-bar').children('.m-header-common-mission-trigger').addClass('is-opened');
      $('body').addClass('blog-logo-overlay');
    });

  }
  else{

    $('.announcement-bar').children('.blog-logo-jukebx').children('img').hover(
      function () {
        $(this).parents('.announcement-bar').children('.m-header-common-mission-trigger').css('display','block');
      },
      function () {
        //         $(this).parents('.announcement-bar').children('.m-header-common-mission-trigger').css('display','none');
      }
    );

    $('.m-header-common-mission-trigger').hover(
      function () {
        $('.m-header-common-mission-trigger').css('display','block');
      },
      function () {
        $('.m-header-common-mission-trigger').css('display','none');
      }
    );

  }
  $('.m-header-common-mission-close').click(function(){
    $(this).parents('.announcement-bar').children('.m-header-common-mission-trigger').removeClass('is-opened');
    $('body').removeClass('blog-logo-overlay');
  });
  $(document).click(function (e) {
    if (!$(e.target).closest('.announcement-bar .blog-logo-jukebx img, .m-header-common-mission-trigger').length) {
      $('.m-header-common-mission-trigger').removeClass('is-opened');
      $('body').removeClass('blog-logo-overlay');
    }
  });


  if( $('.choose-free-sample-grid').length > 0 ){
  const CartDraggedSlider = document.querySelector('.choose-free-sample-grid');  
  let CartisDown = false;
  let CartstartX;
  let CartscrollLeft; 

  CartDraggedSlider.addEventListener('mousedown', (e) => { 
    CartisDown = true;
    CartDraggedSlider.classList.add('active');
    CartstartX = e.pageX - CartDraggedSlider.offsetLeft;
    CartscrollLeft = CartDraggedSlider.scrollLeft;
  });
  CartDraggedSlider.addEventListener('mouseleave', () => {CartisDown = false;CartDraggedSlider.classList.remove('active');});
  CartDraggedSlider.addEventListener('mouseup', () => {CartisDown = false;CartDraggedSlider.classList.remove('active');});
  CartDraggedSlider.addEventListener('mousemove', (e) => {
    if(!CartisDown) return;
    e.preventDefault();
    const Cartx = e.pageX - CartDraggedSlider.offsetLeft;
    const Cartwalk = (Cartx - CartstartX) * 3; //scroll-fast
    CartDraggedSlider.scrollLeft = CartscrollLeft - Cartwalk;
  });
}
});


$(document).on('click', '[videtag]' , function(e){
  e.preventDefault();
 var VideoTag =  $(this).attr('videtag');
 $('body').addClass('videoActive');
 $('body').append(`
   <div class="WrapperPopupWithThumbnail">
     <div class="Container__Wp_thumbnail">
        <div class="CrossPopupThumb"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="96.000000pt" height="96.000000pt" viewBox="0 0 96.000000 96.000000" preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,96.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
<path d="M212 748 c-7 -7 -12 -19 -12 -27 0 -9 51 -66 112 -128 l113 -113 -113 -113 c-61 -62 -112 -119 -112 -128 0 -19 20 -39 39 -39 9 0 66 51 128 112 l113 113 113 -113 c62 -61 119 -112 128 -112 19 0 39 20 39 39 0 9 -51 66 -112 128 l-113 113 113 113 c61 62 112 119 112 128 0 19 -20 39 -39 39 -9 0 -66 -51 -128 -112 l-113 -113 -113 113 c-62 61 -119 112 -128 112 -8 0 -20 -5 -27 -12z"/>
</g>
</svg></div>
<span class="container_overlay-video"> </span>
        <div class="container__Video_init">
          <div class="ContainerVideoExecuted">
            <video playsinline="true" autoplay="true" controls>
              <source src=${VideoTag} type="video/mp4">
            </video>
           </div>
        </div>
        </div>
    </div>
  
 `)
});

$(document).on('click', '.CrossPopupThumb' , function(e){
  e.preventDefault();
  $('.WrapperPopupWithThumbnail').remove();
     $('body').removeClass('videoActive');
});
  
$(document).click(function (e) {
  if (!$(e.target).closest('.video_wrapper, .Container__Wp_thumbnail').length) {
    $('.WrapperPopupWithThumbnail').remove();
    $('body').removeClass('videoActive');
  }
});


 var divisor = document.getElementById("divisor"),
            handle = document.getElementById("handle"),
            slider = document.getElementById("slider");

       
        slider.value = 33; 
        moveDivisor();

        function moveDivisor() {
            var sliderValue = slider.value;
            handle.style.left = sliderValue + "%";
            divisor.style.width = sliderValue + "%";
        }

        function onTouchStart(event) {
            event.preventDefault();
            document.addEventListener('touchmove', onTouchMove);
            document.addEventListener('touchend', onTouchEnd);
        }

        function onTouchMove(event) {
            var sliderRect = slider.getBoundingClientRect();
            var newPosition = (event.touches[0].clientX - sliderRect.left) / sliderRect.width * 100;
            newPosition = Math.max(0, Math.min(100, newPosition));
            slider.value = newPosition;
            moveDivisor();
        }

        function onTouchEnd(event) {
            document.removeEventListener('touchmove', onTouchMove);
            document.removeEventListener('touchend', onTouchEnd);
        }

        function onMouseDown(event) {
            event.preventDefault();
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);
            onMouseMove(event); 
        }

        function onMouseMove(event) {
            var sliderRect = slider.getBoundingClientRect();
            var newPosition = (event.clientX - sliderRect.left) / sliderRect.width * 100;
            newPosition = Math.max(0, Math.min(100, newPosition));
            slider.value = newPosition;
            moveDivisor();
        }

        function onMouseUp(event) {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        }

        window.onload = function() {
            handle.addEventListener('touchstart', onTouchStart);
            handle.addEventListener('mousedown', onMouseDown);
        };